import * as React from "react";
import Game from "./components/Game";

export default () => (
  <>
    <Game />
  </>
);
